import React, { useContext, useEffect, useState } from 'react'
import ColorVariant from 'app/react/components/colors/ColorVariant'
import ColorsContext from 'app/react/components/colors/ColorsContext'

export default function Color (props) {

  const variations = [
    { title: '80%', opacity: 0.8 },
    { title: '60%', opacity: 0.6 },
    { title: '40%', opacity: 0.4 }
  ]

  const { selectedOption, showColorVariations } = useContext(ColorsContext)
  const [currColor, setCurrColor] = useState(null)

  useEffect(() => {
    setCurrColor(props[selectedOption])
  }, [selectedOption])

  return (
    <div className="dm-colors__color">
      <ColorVariant
        title={props.title}
        bgColor={props.hex}
        opacity={1}
        currColor={currColor}
        textIsDark={props.textIsDark}
      />
      {showColorVariations && variations.map((variation, i ) => {
        return (
          <ColorVariant
            key={i}
            title={variation.title}
            bgColor={props.hex}
            opacity={variation.opacity}
            currColor={currColor}
            textIsDark={props.textIsDark}
          />
        )
      })}
    </div>
  )
}